import { render, staticRenderFns } from "./ReviewsLink.vue?vue&type=template&id=16102e38&scoped=true"
import script from "./ReviewsLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewsLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReviewsLink.vue?vue&type=style&index=0&id=16102e38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16102e38",
  null
  
)

export default component.exports